import { render, staticRenderFns } from "./RechargePage.vue?vue&type=template&id=04d8ac3f&scoped=true&"
import script from "./RechargePage.vue?vue&type=script&lang=js&"
export * from "./RechargePage.vue?vue&type=script&lang=js&"
import style0 from "./RechargePage.vue?vue&type=style&index=0&id=04d8ac3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d8ac3f",
  null
  
)

export default component.exports